import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

const GRAFANA_URL =
  'https://goul.org/grafana/d/ai-limits/ai-limits?orgId=1&from=now-24h&to=now&timezone=browser&theme=light&kiosk';

@Component({
  selector: 'app-ai-limits-report',
  standalone: true,
  imports: [CommonModule, ButtonModule, CardModule],
  templateUrl: './ai-limits-report.component.html',
  styleUrls: ['./ai-limits-report.component.css'],
})
export class AiLimitsReportComponent {
  readonly grafanaUrl: SafeResourceUrl;

  constructor(private router: Router, sanitizer: DomSanitizer, titleService: Title) {
    this.grafanaUrl = sanitizer.bypassSecurityTrustResourceUrl(GRAFANA_URL);
    titleService.setTitle('NotesApp - AI Limits');
  }

  close(): void {
    this.router.navigate(['/home']);
  }
}
